export const styles = () => ({
  separator: {
    borderColor: 'rgba(213, 214, 216, 0.5)',
    margin: '6px 0',
    width: '100%',
  },
  blueBackground: { backgroundColor: '#f1f7ff', borderRadius: 20 },
});
